<template src="./Return.html">
</template>

<script>

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.$store
            .dispatch("employeeLeaves/getForEdit", this.itemId)
            .then((res) => {
                this.leave = res;
                this.returnInfo.officialHoliday = res.officialHoliday;
                this.returnInfo.hasOffical = res.hasOffical;
            })
            .catch(() => { });
    },
    computed: {


    },
    data() {
        return {
            leave: {
                description: null,
                employeeId: null,
                startDate: null,
                endDate: null,
                // officialHoliday: null,
                // hasOffical: false,
            },
            returnInfo: {
                returnDate: null,
                remark: null,
                file: null,
                hasOffical: null,
                officialHoliday: null,
            }
        };
    },
    methods: {

        allowedDates(val) {
            const startDate = new Date(this.leave.startDate);
            const endDate = new Date(this.leave.endDate);
            const date = new Date(val);
            return date > startDate && date < endDate;
        },
        confirm() {
            this.$store
                .dispatch("employeeLeaves/return", { id: this.itemId, payload: this.returnInfo })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },
        back() {
            this.$emit("back");
        },
        download() {
            window.open(
                `/api/employeeLeaves/${this.leave.attachmentId}/attachment`,
                "_blank"
            );
        }
    },
};
</script>